import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, shareReplay } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class LayoutService {
  isHandset$ = this.breakpointObserver
    .observe(['(max-width: 575px)'])
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  isTablet$ = this.breakpointObserver
    .observe(['(min-width: 576px) and (max-width: 1400px)'])
    .pipe(
      map(result => result.matches),
      shareReplay()
  );

  isWeb$ = this.breakpointObserver
    .observe(['(min-width: 1401px)'])
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  constructor(private breakpointObserver: BreakpointObserver) {}
}
